module.exports = __webpack_public_path__ + "static/media/sf_3100_gray.ddc97cab86b252b9691344594be48717.png";